import AxiosClient from "../AxiosClient";

export const selectUser = (params) => {
  const url = "/api/user/selectInfoList";
  return AxiosClient.post(url, params);
};

export const selectUserById = (params) => {
  const url = "/api/user/selectUserInfoById";
  return AxiosClient.post(url, params);
};

export const insertUser = (params) => {
  const url = "/api/user/insertInfo";
  return AxiosClient.post(url, params);
};

export const updateUser = (params) => {
  const url = "/api/user/updateInfo";
  return AxiosClient.post(url, params);
};

export const deleteUser = (params) => {
  const url = "/api/user/deleteInfo";
  return AxiosClient.post(url, params);
};

export const typeChoices = () => {
  const url = "/api/user/typeChoices";
  return AxiosClient.post(url);
};

export const customerChoices = () => {
  const url = "/api/user/customerChoices";
  return AxiosClient.post(url);
};
export const shopChoices = () => {
  const url = "/api/user/shopChoices";
  return AxiosClient.post(url);
};
